import apiClient from '@/store/helpers/api-client';

const SET_FORM_VALUE = 'SET_FORM_VALUE';
const UPDATE_ONBOARDING_STEP = 'UPDATE_ONBOARDING_STEP';
const UPDATE_ONBOARDING_STEP_LOADING = 'UPDATE_ONBOARDING_STEP_LOADING';

const state = {
  isUpdatingOnboarding: false,
  page: null,
  role: null,
  frequency: null,
  name: null,
};

const mutations = {
  // eslint-disable-next-line
  [SET_FORM_VALUE](state, { field, value }) {
    // eslint-disable-line
    state[field] = value;
  },
  // eslint-disable-next-line
  [UPDATE_ONBOARDING_STEP_LOADING](state, isLoading) {
    // eslint-disable-line
    state.isUpdatingOnboarding = isLoading;
  },
  // eslint-disable-next-line
  [UPDATE_ONBOARDING_STEP](state, step) {
    // eslint-disable-line
    state.onboardingStep = step;
  },
};

const actions = {
  setFormValue({ commit }, { field, value }) {
    commit(SET_FORM_VALUE, { field, value });
  },

  async updateOnboardingStep({ commit }, page) {
    commit(UPDATE_ONBOARDING_STEP_LOADING, true);

    let response = false;
    const data = {
      name: state.name,
      frequency: state.frequency,
    };
    try {
      await apiClient.post('/set-onboarding-page', { page, data });
      response = true;
    } catch (error) {
      // eslint-disable-next-line
      console.error('Error setting form value:', error);
    }

    commit(UPDATE_ONBOARDING_STEP_LOADING, false);
    return response;
  },
};

export default {
  state,
  mutations,
  actions,
};
